import { FunctionComponent } from 'react';
import { Routes, Route } from 'react-router-dom';
import Articles from 'src/pages/website/Resources/Articles';
import ArticleView from 'src/pages/website/Resources/ArticleView';
import YouTubeVideos from 'src/pages/website/Resources/YouTubeVideos';
import EducationRoutes from './educationRoutes';

const ResourceRoutes: FunctionComponent = () => (
    <Routes>
        <Route path='/' element={<p>resources</p>} />
        <Route path='/articles' element={<Articles />} />
        <Route path='/articles/:id' element={<ArticleView />} />
        <Route path='/videos' element={<YouTubeVideos />} />
        <Route path='/education/*' element={<EducationRoutes />} />
    </Routes> 
);

export default ResourceRoutes;